import { Divider, Flex, Heading, Text, View } from "@aws-amplify/ui-react";

export default function TermsOfServicePage() {
  return (
    <Flex
      direction="column"
      minWidth={650}
      padding="32px 32px 32px 32px"
      backgroundColor="rgba(250,250,250,1)"
    >
      <Flex>
        <View>
          <Text>
            Please read these Terms of Service ("Terms", "Terms of Service")
            carefully before using the *.Total Care Compass website (the "Service")
            operated by Total Care Compass, LLC. ("us", "we", or "our").
          </Text>
          <Text>
            Your access to and use of the Service is conditioned on your
            acceptance of and compliance with these Terms. These Terms apply to
            all visitors, users and others who access or use the Service.
          </Text>
          <Text>
            By accessing or using the Service you agree to be bound by these
            Terms. If you disagree with any part of the terms, then you may not
            access the Service.
          </Text>
        </View>
      </Flex>
      <Flex>
        <View>
          <Heading level={6} children="Termination" />
          <Text>
            We may terminate or suspend access to our Service immediately,
            without prior notice or liability, for any reason whatsoever,
            including without limitation if you breach the Terms.
          </Text>
          <Text>
            All provisions of the Terms which by their nature should survive
            termination shall survive termination, including, without
            limitation, ownership provisions, warranty disclaimers, indemnity
            and limitations of liability.
          </Text>
        </View>
      </Flex>
      <Flex>
        <View>
          <Heading level={6} children="Links To Other Web Sites" />
          <Text>
            Our Service may contain links to third- party web sites or services
            that are not owned or controlled by Total Care Compass, LLC.
          </Text>
          <Text>
            Total Care Compass, LLC has no control over, and assumes no responsibility
            for, the content, privacy policies, or practices of any third-party
            web sites or services. You further acknowledge and agree that PC
            Medfolio, LLC shall not be responsible or liable, directly or
            indirectly, for any damage or loss caused or alleged to be caused by
            or in connection with use of or reliance on any such content, goods
            or services available on or through any such web sites or services.
          </Text>
          <Text>
            We strongly advise you to read the terms and conditions and privacy
            policies of any third- party web sites or services that you visit.
          </Text>
        </View>
      </Flex>
      <Flex>
        <View>
          <Heading level={6} children="Governing Law" />
          <Text>
            These Terms shall be governed and construed in accordance with the
            laws of the United States, State of Michigan, Oakland County without
            regard to its conflict of law provisions.
          </Text>
          <Text>
            Our failure to enforce any right or provision of these Terms will
            not be considered a waiver of those rights. If any provision of
            these Terms is held to be invalid or unenforceable by a court, the
            remaining provisions of these Terms will remain in effect. These
            Terms constitute the entire agreement between us regarding our
            Service and supersede and replace any prior agreements we might have
            between us regarding the Service.
          </Text>
        </View>
      </Flex>
      <Flex>
        <View>
          <Heading level={6} children="Changes" />
          <Text>
            We reserve the right, at our sole discretion, to modify or replace
            these Terms at any time. What constitutes a material change will be
            determined at our sole discretion.
          </Text>
          <Text textDecoration={"underline"}>
            By continuing to access or use our Service after those revisions
            become effective, you agree to be bound by the revised terms. If you
            do not agree to the new terms, please stop using the Service.
          </Text>
        </View>
      </Flex>
      <Flex>
        <View>
          <Heading level={6} children="Contact Us" />
          <Text>
            If you have any questions about these Terms, please contact us at{"  "}
            <Text as="span" textDecoration={"underline"}>
              info@totalcarecompass.com
            </Text>
          </Text>
        </View>
      </Flex>
    </Flex>
  );
}
